import React from 'react';

/**
 * StatusItem Component
 * Renders a single status filter item.
 * 
 * Task: P2-005
 */
const StatusItem = ({
  status,
  label,
  count,
  isSelected,
  isZeroCount,
  onToggle,
  colorClass = 'green'
}) => {
  const colorMap = {
    green: {
      checkbox: 'text-green-600 focus:ring-green-500',
      bg: 'bg-green-50 border-green-200',
      dot: 'bg-green-500'
    },
    red: {
      checkbox: 'text-red-600 focus:ring-red-500',
      bg: 'bg-red-50 border-red-200',
      dot: 'bg-red-500'
    }
  };
  
  const colors = colorMap[colorClass] || colorMap.green;
  
  return (
    <label
      className={`flex items-center justify-between p-2 rounded-lg cursor-pointer transition-colors ${
        isSelected ? `${colors.bg} border` : 
        isZeroCount ? 'opacity-50 bg-slate-50' : 'hover:bg-slate-50'
      }`}
      data-testid={`filter-status-${status}`}
    >
      <div className="flex items-center space-x-2">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={() => onToggle(status)}
          className={`w-4 h-4 border-slate-300 rounded ${colors.checkbox}`}
        />
        <span className={`text-sm ${isZeroCount ? 'text-slate-400' : 'text-slate-700'}`}>
          {label}
        </span>
      </div>
      <div className="flex items-center space-x-2">
        <span className="text-xs text-slate-400 font-mono">({count})</span>
        <span className={`w-2 h-2 ${colors.dot} rounded-full`}></span>
      </div>
    </label>
  );
};

export default StatusItem;
